var render = function () {
  var _vm$order, _vm$order2, _vm$me, _vm$order3, _vm$order4, _vm$order5, _vm$order6, _vm$order6$purchases, _vm$order6$purchases$, _vm$order7, _vm$order7$buyer, _vm$order8, _vm$order8$buyer, _vm$order9, _vm$order9$buyer, _vm$order10, _vm$order10$receiver;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c(_vm.template, {
    tag: "component"
  }, [_vm.ready && _vm.order ? _c('div', [_c('div', {
    staticClass: "contents-area"
  }, [_c('div', {
    staticClass: "tit-wrap tit-wrap--unberline"
  }, [_c('h2', {
    staticClass: "tit"
  }, [_vm._v("주문결과")])]), _c('div', {
    staticClass: "contents-area__inner"
  }, [_c('section', {
    staticClass: "page-section pt-0"
  }, [_vm.resCode == '3001' ? _c('v-data-table', {
    staticClass: "d-flex purchasedetail-table",
    attrs: {
      "items": _vm.purchases,
      "headers": _vm.purchasesHeaders,
      "disable-pagination": "",
      "disable-sort": "",
      "hide-default-footer": "",
      "mobile-breakpoint": "768",
      "width": "100%"
    },
    scopedSlots: _vm._u([{
      key: "item.product",
      fn: function fn(_ref) {
        var _item$product;

        var item = _ref.item;
        return [_c('div', {
          staticClass: "img-wrap border"
        }, [_c('router-link', {
          attrs: {
            "to": "/dshop/products/".concat(item.product._mainProduct || item.product._id)
          }
        }, [_c('v-img', {
          staticClass: "mx-auto",
          attrs: {
            "src": _vm.setImgSrc(item === null || item === void 0 ? void 0 : (_item$product = item.product) === null || _item$product === void 0 ? void 0 : _item$product.thumb),
            "width": "100",
            "aspect-ratio": 1 / 1,
            "contain": "",
            "position": "center"
          }
        })], 1)], 1)];
      }
    }, {
      key: "item.name",
      fn: function fn(_ref2) {
        var _item$product2, _item$product3, _item$product4;

        var item = _ref2.item;
        return _c('v-responsive', {}, [_c('v-flex', [_c('router-link', {
          attrs: {
            "to": "/d-inline-flexshop/products/".concat(item.product._mainProduct || item.product._id)
          }
        }, [_c('div', [_vm._v(_vm._s(item === null || item === void 0 ? void 0 : (_item$product2 = item.product) === null || _item$product2 === void 0 ? void 0 : _item$product2.name))]), ((item === null || item === void 0 ? void 0 : (_item$product3 = item.product) === null || _item$product3 === void 0 ? void 0 : _item$product3.optionalNames) || []).length ? _vm._l(item === null || item === void 0 ? void 0 : (_item$product4 = item.product) === null || _item$product4 === void 0 ? void 0 : _item$product4.optionalNames, function (val, index) {
          var _item$product5;

          return _c('div', {
            key: index
          }, [_vm._v(" " + _vm._s("".concat(val, " : ").concat(item === null || item === void 0 ? void 0 : (_item$product5 = item.product) === null || _item$product5 === void 0 ? void 0 : _item$product5.optionalValues[index])) + " ")]);
        }) : _vm._e()], 2)], 1)], 1);
      }
    }, {
      key: "item.saleAmount",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return _c('v-responsive', {}, [_c('v-flex', [_c('div', {
          staticClass: "mx-2 text-truncate"
        }, [_vm._v(_vm._s(item.saleAmount.format()) + "원")])])], 1);
      }
    }], null, false, 2996617125)
  }) : _c('div', [_c('div', [_vm._v("[" + _vm._s(_vm.resCode) + "]")]), _c('div', [_vm._v("결제가 완료되지 않았습니다")])])], 1), _c('section', {
    staticClass: "page-section py-0 d-flex justify-center secondary"
  }, [_c('div', {
    staticClass: "card--primary"
  }, [_c('v-row', {
    staticClass: "row--small font-size-14"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-sheet', {
    staticClass: "white--text",
    attrs: {
      "color": "transparent",
      "width": "90"
    }
  }, [_vm._v("총 상품가격 :")])], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v(" " + _vm._s((_vm$order = _vm.order) === null || _vm$order === void 0 ? void 0 : _vm$order.totalAmount.format()) + "원 ")])], 1), _c('v-row', {
    staticClass: "row--small font-size-14"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-sheet', {
    staticClass: "white--text",
    attrs: {
      "color": "transparent",
      "width": "90"
    }
  }, [_vm._v("사용 캐시 :")])], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v(" -" + _vm._s((_vm$order2 = _vm.order) === null || _vm$order2 === void 0 ? void 0 : _vm$order2.totalAmount.format()) + "원 ")])], 1), _c('v-row', {
    staticClass: "row--small font-size-14"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-sheet', {
    staticClass: "white--text",
    attrs: {
      "color": "transparent",
      "width": "90"
    }
  }, [_vm._v("잔여 캐시 :")])], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v(" " + _vm._s((((_vm$me = _vm.me) === null || _vm$me === void 0 ? void 0 : _vm$me.cash) - ((_vm$order3 = _vm.order) === null || _vm$order3 === void 0 ? void 0 : _vm$order3.totalAmount)).format()) + "원 ")])], 1)], 1)]), _c('section', {
    staticClass: "page-section"
  }, [_c('table', {
    staticClass: "table--default"
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "20%"
    }
  }), _c('col', {
    staticStyle: {
      "width": "30%"
    }
  }), _c('col', {
    staticStyle: {
      "width": "20%"
    }
  }), _c('col', {
    staticStyle: {
      "width": "30%"
    }
  })]), _c('tr', [_c('th', [_vm._v("주문번호")]), _c('td', [_vm._v(_vm._s((_vm$order4 = _vm.order) === null || _vm$order4 === void 0 ? void 0 : _vm$order4.orderNo))]), _c('th', [_vm._v("주문일")]), _c('td', [_vm._v(_vm._s((_vm$order5 = _vm.order) === null || _vm$order5 === void 0 ? void 0 : _vm$order5.createdAt.toDate()))])]), _c('tr', [_c('th', [_vm._v("결제방법")]), _c('td', [_vm._v("캐시 결제")]), _c('th', [_vm._v("주문상태")]), _vm.resCode !== '3001' ? _c('td', [_vm._v(_vm._s("-"))]) : _vm._e(), _vm.resCode === '3001' ? _c('td', [_vm._v(_vm._s((_vm$order6 = _vm.order) === null || _vm$order6 === void 0 ? void 0 : (_vm$order6$purchases = _vm$order6.purchases) === null || _vm$order6$purchases === void 0 ? void 0 : (_vm$order6$purchases$ = _vm$order6$purchases[0]) === null || _vm$order6$purchases$ === void 0 ? void 0 : _vm$order6$purchases$.status))]) : _vm._e()]), _c('tr', [_c('th', [_vm._v("입금자명")]), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s((_vm$order7 = _vm.order) === null || _vm$order7 === void 0 ? void 0 : (_vm$order7$buyer = _vm$order7.buyer) === null || _vm$order7$buyer === void 0 ? void 0 : _vm$order7$buyer.name))])])])]), _c('section', {
    staticClass: "page-section pb-0"
  }, [_c('div', {
    staticClass: "tit-wrap mb-10px mb-md-20px"
  }, [_c('h3', {
    staticClass: "tit tit--xs"
  }, [_vm._v("주문하신 분")])]), _c('table', {
    staticClass: "table--default"
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "20%"
    }
  }), _c('col', {
    staticStyle: {
      "width": "80%"
    }
  })]), _c('tr', [_c('th', [_vm._v("주문하신분")]), _c('td', [_vm._v(_vm._s((_vm$order8 = _vm.order) === null || _vm$order8 === void 0 ? void 0 : (_vm$order8$buyer = _vm$order8.buyer) === null || _vm$order8$buyer === void 0 ? void 0 : _vm$order8$buyer.name))])]), _c('tr', [_c('th', [_vm._v("연락처")]), _c('td', [_vm._v(_vm._s((_vm$order9 = _vm.order) === null || _vm$order9 === void 0 ? void 0 : (_vm$order9$buyer = _vm$order9.buyer) === null || _vm$order9$buyer === void 0 ? void 0 : _vm$order9$buyer.phone))])]), _c('tr', [_c('th', [_vm._v("받는사람 연락처")]), _c('td', [_vm._v(_vm._s((_vm$order10 = _vm.order) === null || _vm$order10 === void 0 ? void 0 : (_vm$order10$receiver = _vm$order10.receiver) === null || _vm$order10$receiver === void 0 ? void 0 : _vm$order10$receiver.phone))])])])]), _c('div', {
    staticClass: "mt-20px mt-md-30px"
  }, [_c('v-row', {
    staticClass: "row--x-small",
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "large": "",
      "outlined": "",
      "color": "gray",
      "to": "/"
    }
  }, [_c('span', {
    staticClass: "grey--text text--darken-3"
  }, [_vm._v("홈으로가기")])])], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "large": "",
      "color": "primary",
      "to": "/mypage/dshop/orders"
    }
  }, [_vm._v("주문배송확인")])], 1)], 1)], 1)])])]) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }